import { PropsWithChildren } from 'react'

import { Component } from '../BaseComponent/BaseComponent'

type TitleProps = {}

export const Title = ({ children }: PropsWithChildren<TitleProps>) => {
  return <Component.Title>{children}</Component.Title>
}
